import React from "react";
import Box from "@mui/material/Box";
import {
  createfromallfiles,
  createMissingClientPayments,
  getInvoiceSummary,
  clientInvoiceBundleCreateFromAllFiles,
  createAllMissingInvoices,
  getWorkflowErrorLogs,
  collectionToEmail,
} from "API/swesum";
import DashboardCard from "Components/Dashboard/DashboardCard";
import FileUpload from "./FileUpload";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Button, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { LoadingButton } from "@mui/lab";
import SearchModal from "./Components/SearchModal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Tooltip from "@mui/material/Tooltip";

const buttonStyle = {
  width: "100%",
  background: "#1a4079",
  borderRadius: "8px",
  color: "white",
  boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.3)",
  fontSize: "12px",
  padding: "8px 20px",
  "&:hover": {
    opacity: "0.8",
    background: "#1a4079",
  },
  "& span": {
    color: "white",
  },
  "&:disabled": {
    background: "gray",
  },
};

export default function Dashboardworkflows() {
  const [fileLoading, setFileLoading] = useState(false);
  const [bundleLoading, setBundleLoading] = useState(false);
  const [collectionToEmailLoading, setCollectionToEmailLoading] =
    useState(false);
  const [paymentsWaiting, setPaymentsWaiting] = useState(0);
  const [paymentFilesProcess, setPaymentFilesProcess] = useState(0);
  const [invoiceImports, setInvoiceImports] = useState([]);
  const [balanceSummary, setBalanceSummary] = useState(null);
  const [collectionSummary, setCollectionSummary] = useState([]);
  const [interestCount, setInterestCount] = useState(0);
  const [reminderCount, setReminderCount] = useState(0);
  const [paymentFiles, setPaymentFiles] = useState(0);
  const [invoiceFiles, setInvoiceFiles] = useState(0);
  const { openSuccess, openError } = usePopupNotificationContext();
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [workflowErrors, setWorkflowErrors] = useState(0);
  const [invoiceImportStatus, setInvoiceImportStatus] = useState(null);

  const [clientPaymentLoading, setClientPaymentLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        setOpenSearchModal(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleProcessPayments = async () => {
    setFileLoading(true);
    const res = await createfromallfiles();
    if (res.status === 201 && res.data.Data) {
      setPaymentsWaiting(res.data.Data.length);
    } else {
      openError(res.data.Errors.join(", "), 3000);
    }
    await fetchInvoiceSummary();
    setFileLoading(false);
  };

  const handleCollectionToEmail = async () => {
    setCollectionToEmailLoading(true);

    try {
      const res = await collectionToEmail();

      if (res) openSuccess(res.data.Message);
    } catch (error) {
      openError(error.response.data.Message);
    } finally {
      await fetchInvoiceSummary();
      setCollectionToEmailLoading(false);
    }
  };

  const fetchWorkflowErrors = async () => {
    const res = await getWorkflowErrorLogs();

    if (res.status === 200) setWorkflowErrors(res.data.length);
  };

  const fetchInvoiceSummary = async () => {
    const res = await getInvoiceSummary();

    if (res) {
      setInvoiceImports(res.InvoiceImports);
      setPaymentFilesProcess(res.FilesToProcess);
      setBalanceSummary(res.ClientBalances);
      setCollectionSummary(res.CollectionSummaries);
      setInterestCount(res.InterestCount);
      setReminderCount(res.ReminderCount);
      setPaymentFiles(res.PaymentFiles);
      setInvoiceFiles(res.InvoiceFiles);
      setInvoiceImportStatus(res.InvoiceImportStatus);
    }
  };

  const asyncRunCreateWorkflow = async () => {
    setClientPaymentLoading(true);

    try {
      const response = await createMissingClientPayments();

      if (response.status >= 200 && response.status < 300) {
        openSuccess(response.data.Message, 5000);
      } else {
        openError(response.data?.Message || "Något gick fel", 5000);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.Message || error.message || "Något gick fel";
      openError(errorMessage, 3000);
    } finally {
      setClientPaymentLoading(false);
    }
  };

  const asyncHandleOnImportInvoiceColl = async () => {
    try {
      const res = await clientInvoiceBundleCreateFromAllFiles();
      if (res.status === 201) {
        const res2 = await createAllMissingInvoices();
        if (res2.status === 201) {
          openSuccess(`${res.data.Message} ${res2.data.Message}`, 3000);
        }
      }
    } catch (_) {
      openError("Någonting gick fel vid createFromAllFiles", 3000);
    } finally {
      setBundleLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoiceSummary();
    fetchWorkflowErrors();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "1200px",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <div style={{ display: "flex", gap: "1rem" }}>
            <TextField
              size="small"
              label="Sök fakturor"
              fullWidth
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ background: "white" }}
            />

            <Button
              variant="contained"
              onClick={() => setOpenSearchModal(true)}
              sx={{ minWidth: "8rem" }}
            >
              <SearchIcon />
            </Button>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gridAutoRows: "auto",
              gap: "1rem",
            }}
          >
            <DashboardCard
              title="Inbetalningar"
              iconUrl={"/icons/14.svg"}
              extraButtons={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <FileUpload
                    sx={buttonStyle}
                    onSuccess={() => {
                      handleProcessPayments();
                    }}
                    loading={fileLoading}
                  />

                  <Button
                    sx={buttonStyle}
                    onClick={() => navigate("/endcustomerpaid/matching")}
                  >
                    Visa
                  </Button>
                </div>
              }
            >
              <div>
                {`Det finns ${
                  paymentFilesProcess > 0 ? paymentFilesProcess : "inga"
                } filer att bearbeta`}
              </div>
            </DashboardCard>

            <DashboardCard
              title="Exporter till Inkasso"
              buttonText={paymentFiles > 0 || invoiceFiles > 0 ? "Skicka" : ""}
              iconUrl={"/icons/Inkasso.svg"}
              buttonOnClick={handleCollectionToEmail}
              loading={collectionToEmailLoading}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Betalfiler
                  </span>
                  <span style={{ fontSize: "18px" }}>
                    {paymentFiles} <span style={{ fontSize: "12px" }}>st</span>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Fakturafiler
                  </span>
                  <span style={{ fontSize: "18px" }}>
                    {invoiceFiles} <span style={{ fontSize: "12px" }}>st</span>
                  </span>
                </div>
              </div>
            </DashboardCard>

            <DashboardCard
              title="Redo för utskick"
              iconUrl={"/icons/Fakturaköp.svg"}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Påminnelser
                  </span>
                  <Link
                    color={"primary"}
                    onClick={() => navigate("/invoices/reminder")}
                    style={{ fontSize: "18px", width: "fit-content" }}
                  >
                    {reminderCount} <span style={{ fontSize: "12px" }}>st</span>
                    <span style={{ fontSize: "20px" }}> →</span>
                  </Link>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Räntefakturor
                  </span>
                  <Link
                    color={"primary"}
                    onClick={() => navigate("/invoices/interest")}
                    style={{ fontSize: "18px", width: "fit-content" }}
                  >
                    {interestCount} <span style={{ fontSize: "12px" }}>st</span>
                    <span style={{ fontSize: "20px" }}> →</span>
                  </Link>
                </div>
              </div>
            </DashboardCard>

            <DashboardCard
              title="Fakturaimport"
              buttonText="Visa importfakturor"
              iconUrl={"/icons/Fakturaservice.svg"}
              buttonOnClick={() => navigate("/invoices/process")}
            >
              {Array.isArray(invoiceImports) && invoiceImports.length > 0
                ? invoiceImports.map((invoice) => {
                    return (
                      <div style={{ maxHeight: "50px" }}>
                        <span style={{ fontWeight: "bold" }}>
                          {invoice.Name}
                        </span>
                        <span>{invoice.Count} st</span>
                        <span>{invoice.Amount}:-</span>
                      </div>
                    );
                  })
                : "Det finns inga nya fakturor att importera"}
              <p
                style={{
                  position: "absolute",
                  display: "block",
                  top: "0",
                  left: "10px",
                }}
              >
                {invoiceImportStatus != null ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "10px",
                    }}
                  >
                    <Tooltip
                      placement="right"
                      title={invoiceImportStatus.StatusMessage}
                    >
                      {invoiceImportStatus.IsCompleted ? (
                        <CheckCircleIcon
                          color="success"
                          sx={{
                            cursor: "pointer",
                            fontSize: "18px",
                            "&:hover": {
                              transform: "scale(1.2)",
                            },
                          }}
                        />
                      ) : (
                        <CancelIcon
                          color="error"
                          sx={{
                            cursor: "pointer",
                            fontSize: "18px",
                            "&:hover": {
                              transform: "scale(1.2)",
                            },
                          }}
                        />
                      )}
                    </Tooltip>
                  </div>
                ) : null}
              </p>
            </DashboardCard>

            <DashboardCard
              title="Klientutbetalningar"
              iconUrl={"/icons/12.svg"}
              extraButtons={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <LoadingButton
                    sx={buttonStyle}
                    onClick={asyncRunCreateWorkflow}
                    loading={clientPaymentLoading}
                  >
                    Skapa
                  </LoadingButton>

                  <Button
                    sx={buttonStyle}
                    onClick={() => navigate("/clientpaymentsdraft")}
                  >
                    Visa
                  </Button>
                </div>
              }
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Summa
                  </span>
                  <span style={{ fontSize: "18px" }}>
                    {balanceSummary?.TotalAmount
                      ? balanceSummary.TotalAmount
                      : 0}{" "}
                    <span style={{ fontSize: "12px" }}>kr</span>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#00000099" }}>
                    Klienter
                  </span>
                  <span style={{ fontSize: "18px" }}>
                    {balanceSummary?.ClientsCount
                      ? balanceSummary.ClientsCount
                      : 0}{" "}
                    <span style={{ fontSize: "12px" }}>st</span>
                  </span>
                </div>
              </div>
            </DashboardCard>

            <DashboardCard
              title="Faktura Inkasso"
              buttonText="Visa fakturor"
              iconUrl={"/icons/Inkasso 2.svg"}
              buttonOnClick={() => navigate("/invoices/collection")}
            >
              <div style={{ textAlign: "center" }}>
                <Typography>{`Klicka på visa fakturor för att förhandsgranska innan export till inkasso`}</Typography>
              </div>
            </DashboardCard>

            {process.env.REACT_APP_ENV !== "PRODUCTION" ? (
              <DashboardCard
                title="Fakturabunt genväg"
                iconUrl={"/icons/Fakturaservice.svg"}
                extraButtons={
                  <FileUpload
                    sx={buttonStyle}
                    onClickCallback={() => setBundleLoading(true)}
                    onSuccess={asyncHandleOnImportInvoiceColl}
                    onError={() => setBundleLoading(false)}
                    loading={bundleLoading}
                    forceCategory={"FAKTURABUNT"}
                  />
                }
              >
                <div style={{ textAlign: "center" }}>
                  <Typography>{`Genväg för att testa fakturabunt import`}</Typography>
                </div>
              </DashboardCard>
            ) : null}

            <DashboardCard
              title="Arbetsflöden"
              buttonText="Visa"
              iconUrl={"/icons/Personlig service.svg"}
              buttonOnClick={() => navigate("/workflows")}
            >
              <div
                style={
                  workflowErrors > 0
                    ? {
                        textAlign: "center",
                        backgroundColor: "#910000",
                        borderRadius: "0.5rem",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                        color: "white",
                      }
                    : { textAlign: "center" }
                }
              >
                <Typography>{`Det finns ${workflowErrors} st fel att hantera`}</Typography>
              </div>
            </DashboardCard>
          </div>
        </div>
        {openSearchModal ? (
          <SearchModal
            open={openSearchModal}
            initialSearchTerm={searchTerm}
            onClose={() => setOpenSearchModal(false)}
          />
        ) : null}
      </Box>
    </>
  );
}
